/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to false if you don't want Splash screen.
};

//Home Page
const greeting = {
  title: "Andrés Álvarez",
  logo_name: "Andres Alvarez",
  nickname: null,
  subTitle:
    "An aspiring developer and data scientist who loves to take on new and existing projects that challenge his analytical and technological capacities.",
  resumeLink:
    "/CV.pdf",
  portfolio_repository: "https://github.com/Andresaf03",
};

const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/Andresaf03",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/andres-alvarez-flores/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "YouTube",
    link:
      "https://www.youtube.com/channel/UCinFxXn-eWp7uk8Q9ki0TvQ?view_as=subscriber",
    fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
    backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  },
  {
    name: "Gmail",
    link:
      "https://mail.google.com/mail/u/0/?view=cm&fs=1&tf=1&to=andresaf0033@gmail.com&subject=MISSED%20CALL%20EZTRADER&body=Hola,",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Facebook",
    link: "https://www.facebook.com/profile.php?id=100019208281050",
    fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/andresalvarez_f/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: "Development Skills",
      fileName: "FullStackImg",
      skills: [
        "⚡ Analyzing large datasets to extract insights",
        "⚡ Solving complex problems with simple solutions",
        "⚡ Implementing secure access to database",
        "⚡ Developing small scale applications",
      ],
      softwareSkills: [
        {
          skillName: "Python",
          fontAwesomeClassname: "simple-icons:python",
          style: {
            color: "#3776AB",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#4169E1",
          },
        },
        {
          skillName: "R",
          fontAwesomeClassname: "simple-icons:r",
          style: {
            color: "#276DC3",
          },
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "devicon:java",
          style: {
            color: "#007396",
          },
        },
        {
          skillName: "VS Code",
          fontAwesomeClassname: "simple-icons:visualstudiocode",
          style: {
            color: "#007ACC",
          },
        },
        {
          skillName: "Vim",
          fontAwesomeClassname: "simple-icons:vim",
          style: {
            color: "#019733",
          },
        },
        {
          skillName: "Obsidian",
          fontAwesomeClassname: "simple-icons:obsidian",
          style: {
            color: "#7C3AED",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            color: "#F7DF1E",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#2496ED",
          },
        },
        {
          skillName: "Latex",
          fontAwesomeClassname: "simple-icons:latex",
          style: {
            color: "#008080",
          },
        },
        {
          skillName: "Github",
          fontAwesomeClassname: "simple-icons:github",
          style: {
            color: "#181717",
          },
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: {
            color: "#F05032",
          },
        },
        {
          skillName: "Discord",
          fontAwesomeClassname: "simple-icons:discord",
          style: {
            color: "#5865F2",
          },
        },
        {
          skillName: "Bash",
          fontAwesomeClassname: "simple-icons:gnubash",
          style: {
            color: "#4EAA25",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
      ],
    },
  ],
};

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "45%", //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "65%",
    },
    {
      Stack: "Programming",
      progressPercentage: "85%",
    },
  ],
};

//Language Skill
const sLanguage = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Python",
      progressPercentage: "90%",
    },
    {
      Stack: "SQL",
      progressPercentage: "80%",
    },
    {
      Stack: "Java",
      progressPercentage: "75%",
    },
    {
      Stack: "R",
      progressPercentage: "65%",
    },
    {
      Stack: "JavaScript",
      progressPercentage: "50%",
    },
    {
      Stack: "Latex",
      progressPercentage: "50%",
    },
    {
      Stack: "HTML",
      progressPercentage: "35%",
    },
    {
      Stack: "CSS",
      progressPercentage: "30%",
    },
    {
      Stack: "Bash",
      progressPercentage: "25%",
    },
    {
      Stack: "C#",
      progressPercentage: "20%",
    }
  ],
};

//Tools Skill
const tools = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Visual Studio Code", //Insert stack or technology you have experience in
      progressPercentage: "95%", //Insert relative proficiency in percentage
    },
    {
      Stack: "Git",
      progressPercentage: "85%",
    },
    {
      Stack: "Github",
      progressPercentage: "85%",
    },
    {
      Stack: "Obsidian", //Insert stack or technology you have experience in
      progressPercentage: "80%", //Insert relative proficiency in percentage
    },
    {
      Stack: "Docker", //Insert stack or technology you have experience in
      progressPercentage: "75%", //Insert relative proficiency in percentage
    },
    {
      Stack: "Discord", //Insert stack or technology you have experience in
      progressPercentage: "75%", //Insert relative proficiency in percentage
    },
    {
      Stack: "PostgreSQL", //Insert stack or technology you have experience in
      progressPercentage: "70%", //Insert relative proficiency in percentage
    },
    {
      Stack: "MongoDB", //Insert stack or technology you have experience in
      progressPercentage: "60%", //Insert relative proficiency in percentage
    },
    {
      Stack: "Vim", //Insert stack or technology you have experience in
      progressPercentage: "35%", //Insert relative proficiency in percentage
    },
    {
      Stack: "Regex", //Insert stack or technology you have experience in
      progressPercentage: "30%", //Insert relative proficiency in percentage
    }
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "Leetcode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#FFA116",
      },
      profileLink: "https://leetcode.com/u/Andresaf03/",
    },
    {
      siteName: "Hacker Rank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#00EA64",
      },
      profileLink: "https://www.hackerrank.com/profile/andresaf0033",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Bachillerato Alexander Bain",
      subtitle: "I.B High School",
      logo_path: "dragonbab.jpeg",
      alt_name: "IIITDM Kurnool",
      duration: "August 2016 - June 2022",
      cgpa: "9.65 / 10.00",
      descriptions: [
        "⚡ Recognition for achieving the highest GPA of the graduating class at the High School level in Institutions with Programs Incorporated into the National Autonomous University of Mexico (UNAM), 2022.",
        "⚡ Studied basic all-around subjects like Computing, Physics, Biology, Chemistry, Mathematics, Literature, Philosophy, History etc.",
        "⚡ Participated in noumerous extracurricular soports activities.",
        "⚡ Apart from this, I have completed the I.B diploma with a score of 35.",
        "⚡ Placed 2nd in my class.",
        "⚡ Honor band.",
      ],
      website_link: "https://www.bab.edu.mx",
      status: "received",
    },
    {
      title: "Instituto Tecnológico Autónomo de México",
      subtitle: "B.Sc. in Data Science",
      logo_path: "itamlogo.png",
      alt_name: "IIITDM Kurnool",
      duration: "August 2022 - ",
      cgpa: "9.79 / 10.00",
      descriptions: [
        "⚡ Recognition for achieving one of the highest GPA of the year at the National Autonomous Institute of Mexico (ITAM), 2023, 2024.",
        "⚡ Studied basic software engineering subjects like DS, Algoithms, Relational DB, Non Relational SB, AI, Discrete Mathematics etc.",
        "⚡ Developed my Social Service Program at an Student's Organization (ITAM Construye).",
        "⚡ Apart from this, I have done courses on Finance and projects implementing Full Stack Development.",
      ],
      website_link: "https://www.itam.mx",
      status: "current",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Finanzas Personales",
      subtitle: "- UNAM",
      logo_path: "unamlogo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/RVLAYK9H62M5",
      alt_name: "UNAM",
      color_code: "white",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work and Volunteership",
  description:
    "Committed professional, passionate about data science, with excellent leadership, organizational, and teamwork skills. Experienced in setting clear goals and delivering results in high-pressure environments. Proficient in database management and data analysis to provide relevant and actionable recommendations.",
  header_image_path: "experience.svg", //experience.svg
  sections: [
    {
      title: "Work",
      experiences: [
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "English Teacher",
          company: "ITAM Construye",
          company_url: "http://www.itamconstruye.itam.mx",
          logo_path: "itamconstruye.jpg",
          duration: "June 2024 - December 2024",
          location: "Tizapán, Mexico City, Mexico",
          description:
            "Gave out a one year english class to senior citizens that had consistent attendance.",
          features: [
            "- Developed skills to improve learning habits.",
            "- Improved my organization and teaching skills.",
            "- Adjusted the rythm to accommodate the different levels of English proficiency.",
          ],
          color: "#181717",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects make use of a vast variety of the latest technology tools. My best experience is to create diverse projects that benefit from my analitical, statistical and development skills. I'm still trying to gain experience by trying my hands on different types of projects.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "andres.png",
    description:
      "I am available on almost every social media platform, so feel free to reach out to me anytime. Whether you have a question, or you want to collaborate on an exciting project, I’d love to hear from you. You can message me, and I will make every effort to reply within 24 hours. If you have any further inquiries or need additional information about my work or skills, don’t hesitate to get in touch. I’m always open to new opportunities and connecting with like-minded individuals.",
  },
  blogSection: {
    title: "Writing",
    subtitle:
      "I enjoy writing about the events of my life, often in a poetic tone. I would love to hear your thoughts on this example, and if you'd like to see more, feel free to reach out.",
    link: "/beep.pdf",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "Tetelpan, México City-01700, México",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://maps.app.goo.gl/TCcNnNoX9Kb2hCyt6",
  },
  phoneSection: {
    title: "",
    subtitle: "",
  },
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  techStack,
  sLanguage,
  tools,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
};
